import type { OrdenacaoDaGaleria } from "@base/contracts";
import type { OrdenacaoDePerfis } from "./ordenacao-de-perfis";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

export const OPCOES_DE_ORDENACAO_PERFIS: readonly {
  readonly valor: OrdenacaoDePerfis;
  readonly rotulo: string;
}[] = [
  { valor: "atualizado", rotulo: "Atualizado por último" },
  { valor: "antigo", rotulo: "Atualizado há mais tempo" },
  { valor: "nome", rotulo: "Nome (A-Z)" },
];

export const OPCOES_DE_ORDENACAO_REFERENCIAS: readonly {
  readonly valor: OrdenacaoDaGaleria;
  readonly rotulo: string;
}[] = [
  { valor: "recente", rotulo: "Mais recentes" },
  { valor: "antigo", rotulo: "Mais antigos" },
  { valor: "curtidas", rotulo: "Mais curtidos" },
  { valor: "comentarios", rotulo: "Mais comentados" },
  { valor: "perfil", rotulo: "Perfil (A-Z)" },
];

export type FiltroDeAnuncio = "todos" | "anuncio" | "organico";

export const OPCOES_DE_FILTRO_ANUNCIO: readonly {
  readonly valor: FiltroDeAnuncio;
  readonly rotulo: string;
}[] = [
  { valor: "todos", rotulo: "Todos" },
  { valor: "anuncio", rotulo: "Anúncios" },
  { valor: "organico", rotulo: "Orgânicos" },
];

type Props<T extends string> = {
  readonly valor: T;
  readonly opcoes: readonly {
    readonly valor: T;
    readonly rotulo: string;
  }[];
  readonly onChange: (valor: T) => void;
  readonly rotulo?: string;
  readonly ariaLabel?: string;
  readonly classNameTrigger?: string;
};

export function SeletorDeOrdenacao<T extends string>({
  valor,
  opcoes,
  onChange,
  rotulo = "Ordenar",
  ariaLabel = "Ordenar",
  classNameTrigger = "w-[12.5rem]",
}: Props<T>) {
  const id = `sel-${ariaLabel.replace(/\s+/g, "-").toLowerCase()}`;
  return (
    <div className="flex shrink-0 flex-col gap-1.5">
      <Label htmlFor={id} className="text-sm font-medium leading-none">
        {rotulo}
      </Label>
      <Select
        value={valor}
        onValueChange={(proximo) => {
          const opcao = opcoes.find((item) => item.valor === proximo);
          if (opcao) onChange(opcao.valor);
        }}
      >
        <SelectTrigger
          id={id}
          className={`h-11 shrink-0 ${classNameTrigger}`}
          aria-label={ariaLabel}
        >
          <SelectValue placeholder={rotulo} />
        </SelectTrigger>
        <SelectContent>
          {opcoes.map((opcao) => (
            <SelectItem key={opcao.valor} value={opcao.valor}>
              {opcao.rotulo}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
